module.exports = __webpack_public_path__ + "img/40_27.d2aeebaa.png";